import React from 'react'
import MaterialSymbol from '../material-symbol'

const Email = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="email" {...props} />
))

Email.displayName = 'Email'

export default Email
